// extracted by mini-css-extract-plugin
export default {"wrapper":"X5-z","ratingContainer":"Y5-z","ratingValue":"Z5-z","starSprite":"_5-z","ratingLabel":"a6-z","error":"b6-z","errorBox":"c6-z"};